// API base comes from REACT_APP_API_BASE (see frontend/.env.* files).
// Empty in dev -> relative "/api" paths, proxied to the local backend.
const BASE = (process.env.REACT_APP_API_BASE || "") + "/api";

async function get(path) {
  const res = await fetch(`${BASE}${path}`);
  if (!res.ok) throw new Error(`API error ${res.status}: ${path}`);
  return res.json();
}

async function post(path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`API error ${res.status}: ${path}`);
  return res.json();
}

export async function fetchOpenShifts() {
  const data = await get("/shifts/open");
  return data.shifts;
}

export async function fetchClients() {
  const data = await get("/clients");
  return data.clients;
}

export async function fetchWorkers() {
  const data = await get("/workers");
  return data.workers;
}

export async function fetchDistances(clientAddress, workers) {
  const workerAddresses = workers
    .filter(w => w.address)
    .map(w => ({ id: w.id, address: w.address }));
  const data = await post("/distances", { clientAddress, workerAddresses });
  return data.distances;
}
